import { useEffect, useState } from 'react';
import './App.css';
import Block from './components/block/Block';
import { checkForWin, checkForDraw } from './service/GameService'

function App() {

  const ROW = 3, COLUMN = 3;
  const [board, setBoard] = useState([])

  const initBoard = () => {
    const boardArr = [];
    for (let r = 0; r < ROW; r++) {
      const row = [];
      for (let c = 0; c < COLUMN; c++) {
        let block = {
          value: "",
          id: `${r} . ${c}`,
          hasWon: false,
        }
        row.push(block);
      }
      boardArr.push(row);
    }
    return boardArr;
  }

  useEffect(() => {
    const newBoard = initBoard();
    setBoard(newBoard);
  }, [])

  const [turn, setTurn] = useState("X")
  const [hasAWinner, setHasAWinner] = useState(false)
  const [draw, setDraw] = useState(false)

  const onBlockClick = (rowIndex, columnIndex) => {
    const currBlock = board[rowIndex][columnIndex]
    if (currBlock.value) return; // return if current block already has a value

    if (hasAWinner || draw) return; // return if game ended

    currBlock.value = turn;

    const won = checkForWin(board, setBoard, ROW, turn);
    setHasAWinner(won)
    if (won) return;

    const isDraw = checkForDraw(ROW, COLUMN, board);

    setDraw(isDraw)

    setTurn(val => {
      return val === "X" ? "O" : "X"
    })
  }

  const restartGame = () => {
    setTurn("X")
    setHasAWinner(false)
    setDraw(false)
    const newBoard = initBoard();
    setBoard(newBoard);
  }

  return (
    <div className="App">
      <div className="game-header">
        <h1 className="game-title">Tic Tac Toe</h1>

        {hasAWinner && (
          <div className="game-status winner-message">
            🎉 Player "{turn}" Wins! 🎉
          </div>
        )}

        {draw && (
          <div className="game-status draw-message">
            🤝 It's a Draw! 🤝
          </div>
        )}

        {!hasAWinner && !draw && (
          <div className="game-status turn-indicator">
            Player {turn}'s Turn
          </div>
        )}
      </div>

      <div className="board">
        {
          board.map((row, rowIndex) => (
            <div key={rowIndex} className="row">
              {
                row.map((column, columnIndex) => (
                  <Block block={column} key={columnIndex} onClick={() => onBlockClick(rowIndex, columnIndex)} />
                ))
              }
            </div>
          ))
        }
      </div>

      {(draw || hasAWinner) && (
        <div className="game-controls">
          <button className="restart-button" onClick={restartGame}>
            🔄 Play Again
          </button>
        </div>
      )}
    </div>
  );
}

export default App;